module.exports = __webpack_public_path__ + "img/3x.9b1fc4d.jpg";